var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPlayCircle = function SvgIconPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iconPlayCircle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3BB643",
    d: "M47.5 7.5c-22.08 0-40 17.92-40 40s17.92 40 40 40 40-17.92 40-40-17.92-40-40-40"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.597 32.4c-1.123-.715-2.593.092-2.593 1.423v25.352c0 1.332 1.47 2.139 2.593 1.424l19.92-12.676a1.688 1.688 0 0 0 0-2.848z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iconPlayCircle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h96v96H0z"
  })))));
};
export default SvgIconPlayCircle;